import { useWizardStore } from "@/stores/wizard-store";

/**
 * Call after any successful step save. Clears `hydratedVersionId` in the
 * wizard store — since StepDataFetcher/WizardHydrator subscribe to it, this
 * makes them refetch the full payload (fresh step-completion checkmarks
 * included) right away, no navigation or remount required. Plain API
 * functions (not React components) can't use the `useWizardStore()` hook, so
 * this goes through the vanilla `getState()` accessor instead.
 */
export function invalidateWizardHydration(): void {
  useWizardStore.getState().invalidateWizardHydration();
}

/**
 * Monotonic counter shared by every StepDataFetcher/WizardHydrator instance
 * across the tab — module-level, not component state, so it survives the
 * remounts step navigation causes. Two full-payload fetches can end up in
 * flight at once (a page transition's old instance still resolving while the
 * new one's effect has already started a fresh request); without this, an
 * older request's response can land *after* a newer one's and silently
 * overwrite fresh step-completion data with a stale snapshot. Each fetch
 * grabs a ticket before it starts and only applies its result if it's still
 * the most recently issued one by the time it resolves.
 */
let hydrationRequestSeq = 0;

export function startHydrationRequest(): number {
  hydrationRequestSeq += 1;
  return hydrationRequestSeq;
}

export function isLatestHydrationRequest(seq: number): boolean {
  return seq === hydrationRequestSeq;
}
